import { PlusSmIcon } from "@heroicons/react/outline";

const PlusIcon = ({ onClick }: { onClick?: () => void }) => {
  return (
    <div
      className="cursor-pointer bg-primaryColor-normal rounded-full p-1 text-white hover:bg-primaryColor-medium transition duration-300"
      onClick={onClick}
    >
      <PlusSmIcon className="h-5 w-5" />
    </div>
  );
};

export default PlusIcon;
